/**
 * Product Hero Badges (compatibility wrapper)
 * Badges that stick to the hero product image. Shows max 3 badges.
 *
 * Thin wrapper over the canonical <BadgeList variant="hero" />. Accepts either
 * a canonical `badges: Badge[]` array (preferred) or a legacy `product` object
 * (falls back to client determineBadges()).
 */

import { BadgeList } from './badge-list'
import { determineBadges, type Badge } from './config'
import { badgesFromTypes } from './select'

interface ProductHeroBadgesProps {
  /** Canonical server-computed badges (preferred). */
  badges?: Badge[]
  /** Legacy product object — used only if `badges` is not provided. */
  product?: any
  position?: 'left' | 'right' // Which side of image
  maxBadges?: number // Max badges to show (default 3)
}

export function ProductHeroBadges({
  badges,
  product,
  position = 'left',
  maxBadges = 3,
}: ProductHeroBadgesProps) {
  const resolved = badges ?? (product ? badgesFromTypes(determineBadges(product)) : [])
  return (
    <BadgeList
      badges={resolved}
      variant="hero"
      max={maxBadges}
      placement={position === 'right' ? 'overlay-tr' : 'overlay-tl'}
    />
  )
}
